define([], function() {
    var _self;
    // console.log('modal');

    // obj
    _self = {
        focus: function($modal) {
            $modal.find('input:visible').first().focus();
        },
        onOpen: function($modal) {
            var $parent = $modal.parent();

            // append to body
            // $modal.appendTo('body');

            // keep parent ref
            $modal.data('parent', $parent);
        },
        onClose: function($modal) {
            var $parent = $modal.data('parent');

            // append to original parent
            // $modal.appendTo($parent);

            // pause videos
            _self.pauseVideo($modal);
        },
        pauseVideo: function($modal) {
            $modal.find('video').each(function() {
                $(this)[0].pause();
            });
        },
        restartSlider: function($modal) {
            var $cycle = $modal.find('.slider__cycle'),
                $dots = $modal.find('.slick-dots');

            if ($cycle.length) {
                $cycle.slick('reinit');
            }
            if ($dots.length) {
                $dots.first().remove();
            }
        }
    };


    // -------------------
    // BINDS
    // -------------------

    // ---------------- modal hack
    $('body').on('show.bs.modal', '.modal', function() {
        _self.onOpen($(this));
    });
    $('body').on('shown.bs.modal', '.modal', function() {
        _self.restartSlider($(this));
    });
    $('body').on('hidden.bs.modal', '.modal', function() {
        _self.onClose($(this));
    });

    return _self;
});
